'use client';

import { Cms } from '@bytel/product-wall';
import {
    Justifiable,
    Row,
    Spacer,
    SpacerSize,
    Text,
    TextLevels,
    TypographyAlign,
    TypographyBold,
    View,
} from '@bytel/trilogy-react';

import { InlinePrice } from '@components/inline-price';
import { PromoHomeSticker } from '@components/promo-home-sticker';

import { capitalize, formatPrice } from '@helpers/wording';

interface TicketLineProps {
    title: string;
    basePrice: number;
    price: number;
    priceDuration?: number;
    period?: string;
    obligationLabel?: string;
    promoAmount?: number;
    promoName?: string;
    promoAlt?: string;
    isBold?: boolean;
    isLoading?: boolean;
}

export function TicketLine({
    title,
    price,
    basePrice,
    promoAmount,
    promoName,
    promoAlt,
    priceDuration,
    period,
    obligationLabel,
    isBold = true,
    isLoading = true,
    ...props
}: Readonly<TicketLineProps>) {
    return (
        <Row {...props}>
            <View flexable justify={Justifiable.SPACE_BETWEEN}>
                <div>
                    <Text
                        marginless
                        typo={[isBold ? TypographyBold.TEXT_WEIGHT_SEMIBOLD : '', TypographyAlign.TEXT_LEFT]}
                        className='mb-small'
                    >
                        <Cms content={title} />
                    </Text>
                    {priceDuration && priceDuration > 0 ? (
                        <Text marginless level={TextLevels.THREE}>
                            {`Pendant ${priceDuration} mois puis ${formatPrice(basePrice)}/mois`}
                        </Text>
                    ) : null}
                    {obligationLabel && (
                        // div is used for skeleton loading, don't remove it
                        <div>
                            <Text marginless level={TextLevels.THREE}>
                                {capitalize(obligationLabel)}
                            </Text>
                        </div>
                    )}
                </div>
                <InlinePrice level={TextLevels.TWO} amount={price} period={period} />
            </View>
            {!isLoading ? (
                <>
                    <Spacer size={SpacerSize.ONE} />
                    <PromoHomeSticker promo={{ value: promoAmount, pennant: promoName }} alt={promoAlt} />
                </>
            ) : null}
        </Row>
    );
}
